import React, { useRef } from 'react';
import ForceGraph3D, {
    ForceGraphMethods,
    LinkObject,
    NodeObject,
} from 'react-force-graph-3d';
import { Dictionary } from '../../../../lib';
import {
    graphSettings,
    linkSettings,
    getNodeColor,
    getNodeSettings,
} from '../lifegraph-explorer/lifegraph-explorer-helper';
import './customToolTip.css'; //CSS file is used due to the inability of react-force-graph to inject inline class styles directly.

export interface Lifegraph3DProps {
    width: number;
    height: number;
    graphData: any;
    setDrawerOpen: Function;
    setSelectedNode: Function;
    nodeColors: Record<string, string>;
    dictionaries: Dictionary[];
}

export const Graph3D = (props: Lifegraph3DProps): React.JSX.Element => {
    const {
        graphData,
        width,
        height,
        setDrawerOpen,
        setSelectedNode,
        nodeColors,
        dictionaries,
    } = props;
    const graphRef = useRef<ForceGraphMethods>();

    const handleGraphClick = (object: NodeObject | LinkObject): void => {
        setSelectedNode(object);
        setDrawerOpen(true);
    };

    return (
        <ForceGraph3D
            height={height}
            width={width}
            ref={graphRef}
            graphData={graphData}
            onNodeClick={(node: NodeObject): void => {
                handleGraphClick(node);
            }}
            onLinkClick={(link: LinkObject): void => {
                handleGraphClick(link);
            }}
            nodeColor={(node: any): string => {
                return getNodeColor(node, nodeColors);
            }}
            showNavInfo={false}
            {...graphSettings}
            {...linkSettings}
            {...getNodeSettings(dictionaries)}
            onNodeDragEnd={(node: any): void => {
                node.fx = node.x;
                node.fy = node.y;
                node.fz = node.z;
            }}
        />
    );
};
